export default "__VITE_ASSET__D6u7y7dD__"